export const EMPTY_ARTICLE_NAME = 'Article title is empty';
export const NON_ARTICLE_DOI_ERROR = 'Only article DOIs are allowed. Please remove non-article DOI.';
export const DUPLICATE_ARTICLE_DOI_ERROR = 'Duplicate articles are not allowed. Please remove a duplicate.';
export const EMPTY_DOI = 'Article DOI cannot be empty.';
export const INVALID_DOI = (plural:boolean) => `Provided article DOI${plural ? 's are' : ' is'} not valid. Please fix or remove`;
export const EMPTY_HEADER = 'Header cannot be empty.';
export const INVALID_HEADER = 'Max heading length (500) is exceeded.';
